var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExportinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8v7.2a2.91 2.91 0 01-3 2.8H3a2.91 2.91 0 01-3-2.8V8a1 1 0 012 0v7.2a.93.93 0 001 .8h16a.93.93 0 001-.8V8a1 1 0 012 0zM8.59 4.83L10 3.41V12a1 1 0 002 0V3.41l1.41 1.42a1 1 0 001.71-.71 1 1 0 00-.29-.71L11.71.29a1 1 0 00-.64-.29h-.19a1 1 0 00-.54.24h-.05L7.17 3.41a1.004 1.004 0 001.42 1.42z",
    fill: "#30CD9A"
  })));
}

export default SvgExportinline;